export default class Stores {
  static AuthenticationStore: string = 'authenticationStore'
  static RoleStore: string = 'roleStore'
  static TenantStore: string = 'tenantStore'
  static UserStore: string = 'userStore'
  static SessionStore: string = 'sessionStore'
  static AccountStore: string = 'accountStore'
  static LanguageStore: string = 'languageStore'
  static AppDataStore: string = 'appDataStore'

  // Master data

  // Resident & Staff & Shop owner
  static StaffStore: string = 'staffStore'
  static PartnerStore: string = 'partnerStore'
  static CustomerStore: string = 'customerStore'

  // News & Event
  static NewsStore: string = 'newsStore'
  static NewsCategoryStore: string = 'newsCategoryStore'
  static FeedbackStore: string = 'feedbackStore'
  static AnnouncementStore: string = 'announcementStore'

  // Finance
  static FinanceStore: string = 'financeStore'
  static WithdrawStore: string = 'withdrawStore'
  static CashAdvanceStore: string = 'cashAdvanceStore'
  static ReceiptStore: string = 'receiptStore'
  static ExpenseMandateStore: string = 'expenseMandateStore'
  static FeeTypeStore: string = 'feeTypeStore'

  // File
  static FileStore: string = 'fileStore'

  // Common
  static AuditLogStore: string = 'auditLogStore'
  static CommentStore: string = 'commentStore'
  static NotificationTemplateStore: string = 'notificationTemplateStore'
  static TermConditionStore: string = 'termConditionStore'

  // Reminder
  static ReminderStore: string = 'reminderStore'

  // Project
  static ProjectStore: string = 'projectStore'
  static CompanyStore: string = 'companyStore'
  static RequirementStore: string = 'requirementStore'
  static UnitStore: string = 'unitStore'
  static ListingStore: string = 'listingStore'

  // Campaign
  static CampaignStore: string = 'campaignStore'
  static TargetStore: string = 'targetStore'

  // Industrial
  static IndustrialStore: string = 'industrialStore'

  //bPeriod
  static PeriodStore: string = 'periodStore'

  // Legal
  static LegalStore: string = 'legalStore'

  // AMFM
  static AmfmStore: string = 'amfmStore'

  // CapitalMarket
  static CapitalMarketStore: string = 'capitalMarketStore'

  // Construction
  static ConstructionStore: string = 'constructionStore'
  //Entity
  static EntityStore: string = 'entityStore'

  //phase
  static PhaseStore: string = 'phaseStore'
  static IndustrialParkStore: string = 'industrialParkStore'

  // report
  static ReportStore: string = 'reportStore'

  static PbiSettingStore: string = 'pbiSettingStore'
}
